import type { FC } from 'react';
import parse from 'html-react-parser';

import { cn } from '@/lib/utils';

import { Card } from '@/components/atoms/Card';
import { LocalImage } from '@/components/atoms/LocalImage';
import { P } from '@/components/atoms/Typography/P';
import { Title } from '@/components/atoms/Typography/Title';

import type { IconOrImageCardTemplateProps } from './IconOrImageCardTemplate.types';

const IconOrImageCardTemplate: FC<IconOrImageCardTemplateProps> = ({
    heading,
    content,
    image,
    Icon,
    justifyBetween,
    iconProps,
    className,
    ...cardProps
}) => (
    <Card
        size="l"
        variant="shadow"
        className={cn(
            'mx-1 my-4 flex h-full w-fit max-w-[320px] flex-col gap-4 self-stretch lg:m-0 lg:max-w-full',
            className,
            justifyBetween ? 'justify-between' : 'justify-start',
        )}
        {...cardProps}
    >
        {!!Icon && (
            <span>
                <Icon
                    className="h-auto min-w-8"
                    {...iconProps}
                />
            </span>
        )}

        <Title size="m">{heading}</Title>

        <P className={'self-stretch text-grey-600'}>{parse(content)}</P>

        {!!image && (
            <LocalImage
                src={image.src}
                alt={image.alt}
                height={24}
                width={104}
                className="my-2"
            />
        )}
    </Card>
);

export default IconOrImageCardTemplate;
